import {
  ATTACHMENT_STATUS_COMPLETED,
  ATTACHMENT_STATUS_UPLOADING,
} from "../constants";
import type { StoredAttachment } from "../hooks/useAttachmentsUpload";
import { FormAttachment } from "./forms/FormAttachment";

interface ConversationViewAttachmentsProps {
  attachments: StoredAttachment[];
  cancelAttachment: (url: string) => void;
}

export const ConversationViewAttachments = ({
  attachments,
  cancelAttachment,
}: ConversationViewAttachmentsProps) => (
  <div className="flex flex-col gap-2 px-4">
    {attachments.length > 0 &&
      attachments.map(attachment => (
        <FormAttachment
          key={attachment.url}
          attachment={{
            ...attachment,
            status: attachment.completed
              ? ATTACHMENT_STATUS_COMPLETED
              : ATTACHMENT_STATUS_UPLOADING,
          }}
          onCancel={cancelAttachment}
        />
      ))}
  </div>
);
